import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { RoomGuestListType } from "@lifeat/shared/data-models/Rooms/RoomGuest";
import { RoomModerationInfoCollection } from "@lifeat/shared/data-models/Rooms/RoomModerationTypes";
import useDbValueListener from "@hooks/useDbValueListener";
import { useRoomContext } from "../../RoomContext";
import { RoomParams } from "../../RoomTypes";
import { RoomModal } from "../RoomModalCommonElements";
import { RoomMembersList } from "./RoomMembersList";
import { RoomMembersSummaryStats } from "./RoomMembersSummaryStats";

const StyledRoomModal = styled(RoomModal)`
    .lifeat-modal {
        height: 500px;
    }
`;

interface RoomMembersModalProps {
    readonly guests: RoomGuestListType;
    readonly roomOwnerUid: string | undefined;
    readonly isOpen: boolean;
    readonly handleClose: () => void;
}
export function RoomMembersModal(props: RoomMembersModalProps) {
    const { roomId }: RoomParams = useParams();
    const { setTotalMemberCount } = useRoomContext();

    const memberCount = useDbValueListener(
        RoomModerationInfoCollection.at(roomId).at("allRoomMembersInfo").at("roomMemberCount").node,
    );

    // Update context value for total member count
    useEffect(() => {
        setTotalMemberCount(memberCount);
    }, [memberCount]);

    return (
        <StyledRoomModal key={`room-members-modal`} isOpen={props.isOpen} closeModal={props.handleClose}>
            <RoomMembersSummaryStats
                onlineMembers={Object.keys(props.guests ?? {}).length}
                totalMembers={memberCount}
            />
            <RoomMembersList onlineGuests={props.guests} roomOwnerUid={props.roomOwnerUid} />
        </StyledRoomModal>
    );
}
